/**
 * Formatting helpers.
 *
 * `null` is the platform's way of saying "not measured", and it must never be
 * rendered as 0 or £0. Every formatter here returns the NO DATA marker for
 * null rather than inventing a number.
 */
export const NO_DATA = 'NO DATA';

export function gbp(value: number | null, decimals = 2): string {
  if (value === null) return NO_DATA;
  return new Intl.NumberFormat('en-GB', {
    style: 'currency', currency: 'GBP',
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  }).format(value);
}

export function count(value: number | null): string {
  if (value === null) return NO_DATA;
  return new Intl.NumberFormat('en-GB').format(value);
}

export function percent(value: number | null): string {
  if (value === null) return NO_DATA;
  return `${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 }).format(value)}%`;
}

/** Applied to every cell that may read NO DATA, so absence looks like absence. */
export function faintIfNull(value: unknown): { color?: string } {
  return value === null || value === undefined ? { color: 'var(--text-faint)' } : {};
}

export function statusPill(status: string): string {
  const s = status.toUpperCase();
  if (s === 'ENABLED') return 'pill good';
  if (s === 'PAUSED') return 'pill warn';
  if (s === 'REMOVED' || s === 'DISABLED') return 'pill bad';
  return 'pill';
}
